import {
  getRankingResultsRequest,
  getRankingResultsResponse,
} from '@core-api/presentation/presentation/interactive-content/{interactive_content_id}/ranking-results';
import { getFetchResultsCacheKey } from '@mentimeter/core-hooks';
import { useFetchResultsBase } from './use-fetch-results-base';

interface UseFetchRankingResultsParams {
  adminKey: string;
  interactiveContentId: string;
  shouldFetchResults: boolean;
  sessionId: number | undefined;
}

export const useFetchRankingResults = ({
  adminKey,
  interactiveContentId,
  shouldFetchResults,
  sessionId,
}: UseFetchRankingResultsParams) => {
  const requestParams = { interactiveContentId };
  const cacheKey = adminKey
    ? getFetchResultsCacheKey('ranking', adminKey, sessionId)
    : null;

  return useFetchResultsBase({
    requestParams,
    cacheKey,
    shouldFetchResults,
    sessionId,
    getRequest: getRankingResultsRequest,
    getResponse: getRankingResultsResponse,
  });
};
